import { render } from "./Ticket.vue?vue&type=template&id=6944e14c"
const script = {}
script.render = render

export default script